import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { RecordsService } from './records.service';
import { AcademicRecordsComponent } from './academic-records/academic-records.component';
import { CcActivityComponent } from './cc-activity/cc-activity.component';
import { TechSkillComponent } from './tech-skill/tech-skill.component';
import { EcActivityComponent } from './ec-activity/ec-activity.component';
import { AchievementRecordsComponent } from './achievement-records/achievement-records.component';
import { HobListComponent } from './hob-list/hob-list.component';
import { ProjectRecordsComponent } from './project-records/project-records.component';
import { ContactRecordsComponent } from './contact-records/contact-records.component';


@NgModule({
  declarations: [
    AppComponent,
    AcademicRecordsComponent,
    CcActivityComponent,
    TechSkillComponent,
    EcActivityComponent,
    AchievementRecordsComponent,
    HobListComponent,
    ProjectRecordsComponent,
    ContactRecordsComponent,
 

  ],
  imports: [
    BrowserModule,
    HttpClientModule,
   
  ],
  providers: [RecordsService],
  bootstrap: [AppComponent]
})
export class AppModule { }
